// ResourcePlanModal.jsx
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import ClearIcon from 'common/shared-ui/src/icons/ClearIcon';

import { useTranslation } from '../../../../packages/common/utils/getLocalString';

// Original class: modalRoot
const StyledModalRoot = styled(Modal)(theme => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '&.MuiModal-root': {
    zIndex: 2000,
  },
}));
// Original class: modalPaper
const StyledModalPaper = styled(Grid)(({ theme }) => ({
  backgroundColor: '#F1F2F8',
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  borderRadius: theme.spacing(4),
  maxWidth: 310,
  maxHeight: '97%',
  overflowY: 'auto',
}));
const ResourcePlanCashModal = ({
  isCashOpen,
  setIsClearing,
  setIsSaving,
  handleCashClose,
}) => {
  const getLocalString = useTranslation();
  const handleClick = closeOption => {
    if (closeOption === 'save_all') {
      setIsSaving(true);
      handleCashClose();
    } else if (closeOption === 'cancel_changes') {
      setIsClearing(true);
      handleCashClose();
    }
  };
  return (
    <>
      <StyledModalRoot
        open={isCashOpen}
        // onClose={handleCashClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <StyledModalPaper container direction='column' wrap='nowrap'>
          <Grid
            container
            wrap='nowrap'
            sx={{
              justifyContent: 'right',
              alignItems: 'right',
              marginBottom: 10,
              marginTop: 5,
            }}
          >
            {/* <IconButton disableRipple onClick={handleCashClose}>
              <Box width={24} height={24}>
                <ClearIcon width={24} height={24} viewBox="0 0 24 24" />
              </Box>
            </IconButton> */}
          </Grid>
          <Grid
            container
            direction='column'
            wrap='nowrap'
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <Typography
              variant='h3'
              sx={{
                fontWeight: 700,
              }}
            >
              {getLocalString('messages', 'unsavedChanges')}
            </Typography>
            <Typography
              variant='h3'
              sx={{
                fontWeight: 700,
              }}
            >
              {getLocalString('messages', 'save')}
            </Typography>
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: 'center',
              marginBottom: 5,
            }}
          >
            <Button
              disableRipple
              variant='defaultBlueSecondary'
              onClick={() => handleClick('save_all')}
            >
              <Typography
                variant='h5'
                sx={{
                  fontWeight: 700,
                }}
              >
                {getLocalString('labels', 'yes')}
              </Typography>
            </Button>
            <Box
              sx={{
                marginLeft: 1,
              }}
            >
              <Button
                disableRipple
                variant='defaultGreyPrimary'
                onClick={() => handleClick('cancel_changes')}
              >
                <Typography
                  variant='h5'
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  {getLocalString('labels', 'no')}
                </Typography>
              </Button>
            </Box>
          </Grid>
        </StyledModalPaper>
      </StyledModalRoot>
    </>
  );
};

export default ResourcePlanCashModal;
